import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '@/providers/AuthProvider';

export default function LandingPage() {
  const navigate = useNavigate();
  const { loaded, user, userAttributes, isTrialExpired } = useAuth();

  useEffect(() => {
    if (!loaded) {
      return;
    }

    // If trial is expired, go to sign-in to show modal
    if (isTrialExpired) {
      navigate('/auth/sign-in');
      return;
    }

    // If no user, go to sign-in
    if (!user) {
      navigate('/auth/sign-in');
      return;
    }

    const visitedGuide = userAttributes && userAttributes['custom:visited_guide'] === '1';

    if (visitedGuide) {
      navigate('/dashboard');
    } else {
      navigate('/guide');
    }
  }, [loaded, user, userAttributes, isTrialExpired, navigate]);

  return <></>;
}
